import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, HostListener, ElementRef} from '@angular/core';
import { IDropDownOptions } from './luci-dropdown.model';

@Component({
  selector: 'luci-dropdown',
  templateUrl: './luci-dropdown.component.html',
  styleUrls: ['./luci-dropdown.component.scss']
})
export class LuciDropdownComponent implements OnInit, OnChanges {

  @Input() isIconMenu = '';
  @Input() label =  '';
  @Input() placeholder =  '';
  @Input() items = [];
  @Input() filterError = 'No records found';
  @Input() multiSelect = false;
  @Input() maxCountDisplay =  3;
  @Input() classList = '';
  @Input() selectedOption = '';
  @Input() isDisabled = false;

  @Output() updateSelectedItem = new EventEmitter();
  @Output() clearItems = new EventEmitter();
  @Output() updateFilter = new EventEmitter();

  selectedItems = [];
  isOpen = false;
  searchQuery = '';
  menuItems = [];
  arrowKeyLocation = 0;
  allSelected =  false;

  @HostListener('document:click', ['$event'])
  clickOut(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.searchQuery = '';
    }
  }
  constructor(private eRef: ElementRef) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      this.menuItems = [...changes.items.currentValue];
      this.items = [...this.sortData(this.menuItems)];
      this.arrowKeyLocation = 0;
    }
  }

  getWidth(){
    return {
      width: this.eRef.nativeElement.querySelector('#dropdown-search').offsetWidth + 'px',
      'max-width': this.eRef.nativeElement.querySelector('#dropdown-search').offsetWidth + 'px'
    };
  }

  clear() {
    // this.isOpen = false;
    this.searchQuery = '';
  }

  getSelectedItem(){
    return this.items.filter((item) => item.value === this.selectedOption)[0].name;
  }

  selectItem($event, item) {
    if (!this.multiSelect) {
      this.selectedOption = item.value;
      this.isOpen = false;
      this.updateFilter.emit(item.value);
    }
    if (this.multiSelect) {
      item.selected = $event.target.checked;
      const  selectedItems = [];
      const itemList =  [...this.items];
      const updatedItemList = itemList.map((listItem, key) => {
        if (listItem.id === item.id) {
          listItem.selected = item.selected;
        }
        if (listItem.selected) {
          selectedItems.push(listItem);
        }
        return listItem;
      });
      this.allSelected = updatedItemList.every(menuItem => menuItem.selected === true);
      this.selectedItems = [...selectedItems];
    }
    this.updateSelectedItem.emit(this.selectedItems);
  }

  updateTags(event) {
    this.selectedItems.splice(event.index, 1);
    const itemList =  [...this.items];
    const updatedItemList = itemList.map((listItem, key) => {
      if (listItem.id === event.tag.id) {
        listItem.selected = false;
      }
      return listItem;
    });
    this.items = [...updatedItemList];
    this.updateSelectedItem.emit(this.selectedItems);
  }

  filterData() {
    const idList = this.selectedItems.map((item) => item.id);
    const filterItems = this.menuItems.filter((item) => item.name.toLowerCase().includes(this.searchQuery.toLowerCase()) &&
      idList.indexOf(item.id) === -1);
    this.items = [...this.sortData(filterItems)];
    this.arrowKeyLocation = this.items.length < this.arrowKeyLocation ? 0 :  this.arrowKeyLocation;
  }

  sortData(data) {
    return data.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
  }

  selectAll(event) {
    this.items.map(data => data.selected = event.target.checked);
    this.selectedItems = this.items.filter((item) => item.selected);
    this.updateSelectedItem.emit(this.selectedItems);
  }

  getIcon(icon) {
    return `assets/icons/luci.svg#${icon}`;
  }

  toggle() {
    if (this.isDisabled){
      return true;
    }
    this.isOpen = !this.isOpen;
  }
}
